<template>
  <v-data-table
    :headers="headersInterrupcoesAging"
    :items="lista.itens"
    :single-expand="singleExpand"
    :expanded.sync="expanded"
    expanded-button="text-red"
    item-key="item"
    show-expand
    class="custom_table elevation-4"
    item-class="bg-error"
    hide-default-footer
    disable-sort
    disable-pagination
  >
    <template v-slot:body.prepend v-if="!nivelUnico">
      <tr>
        <td class="expand-aging">  
          <v-icon v-if="!btnExpand" @click="expandAll(lista.itens)">                
            v-icon notranslate v-data-table__expand-icon v-icon--link mdi mdi-chevron-down theme--light
          </v-icon>
          <v-icon v-else @click="expandAll(lista.itens)">                
            v-icon notranslate v-data-table__expand-icon v-icon--link mdi mdi-chevron-down theme--light v-data-table__expand-icon--active
          </v-icon>                           
        </td>
        <td class="titulo-aging">
          {{ descricaoTitulo }}
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,null,null,0,0,'0')">
            {{ lista.totais.aging.aging_0 }}
          </span>
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,null,null,0,0,'1')">
            {{ lista.totais.aging.aging_1 }}
          </span>
        </td>            
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,null,null,0,0,'2')">
            {{ lista.totais.aging.aging_2 }}
          </span> 
        </td>            
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,null,null,0,0,'3')">
            {{ lista.totais.aging.aging_3 }}
          </span> 
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,null,null,0,0,'4')">
            {{ lista.totais.aging.aging_4 }}
          </span>         
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,null,null,0,0,'5')">
            {{ lista.totais.aging.aging_5 }}
          </span>
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,null,null,0,0,'6')">
            {{ lista.totais.aging.aging_6 }}
          </span>
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,null,null,0,0,'7')">
            {{ lista.totais.aging.aging_7 }}
          </span>
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,null,null,0,0,'8_10')">
            {{ lista.totais.aging.aging_8_10 }}
          </span>
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,null,null,0,0,'11_15')">
            {{ lista.totais.aging.aging_11_15 }}
          </span>
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,null,null,0,0,'16_30')">
            {{ lista.totais.aging.aging_16_30 }}
          </span>
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,null,null,0,0,'31_60')">
            {{ lista.totais.aging.aging_31_60 }}
          </span>
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,null,null,0,0,'maior_60')">
            {{ lista.totais.aging.aging_maior_60 }}
          </span>
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,null,null,0,0,null)">
            {{ lista.totais.aging.aging_total }}
          </span>
        </td>
      </tr>
    </template>

    <template v-slot:item="{ item }">
      <tr>
        <td class="expand-aging">
          <span v-if="!nivelUnico">
            <v-icon v-if="!btnExpand" @click="toggleExpand(item)">                
              v-icon notranslate v-data-table__expand-icon v-icon--link mdi mdi-chevron-down theme--light
            </v-icon>
            <v-icon v-else @click="toggleExpand(item)">                
              v-icon notranslate v-data-table__expand-icon v-icon--link mdi mdi-chevron-down theme--light v-data-table__expand-icon--active
            </v-icon>
          </span>  
        </td>
        <td class="titulo-aging">
          <span>{{ (!nivelUnico) ? item.item: 'TOTAL' }}</span>
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,item.ctrl_processo_id ?? null,null,0,0,'0', item.ctrl_familia_id ?? null)">{{ item.aging.aging_0 }}</span>
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,item.ctrl_processo_id ?? null,null,0,0,'1', item.ctrl_familia_id ?? null)">{{ item.aging.aging_1 }}</span>
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,item.ctrl_processo_id ?? null,null,0,0,'2', item.ctrl_familia_id ?? null)">{{ item.aging.aging_2 }}</span>
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,item.ctrl_processo_id ?? null,null,0,0,'3', item.ctrl_familia_id ?? null)">{{ item.aging.aging_3 }}</span>
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,item.ctrl_processo_id ?? null,null,0,0,'4', item.ctrl_familia_id ?? null)">{{ item.aging.aging_4 }}</span>
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,item.ctrl_processo_id ?? null,null,0,0,'5', item.ctrl_familia_id ?? null)">{{ item.aging.aging_5 }}</span>
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,item.ctrl_processo_id ?? null,null,0,0,'6', item.ctrl_familia_id ?? null)">{{ item.aging.aging_6 }}</span>
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,item.ctrl_processo_id ?? null,null,0,0,'7', item.ctrl_familia_id ?? null)">{{ item.aging.aging_7 }}</span>
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,item.ctrl_processo_id ?? null,null,0,0,'8_10', item.ctrl_familia_id ?? null)">{{ item.aging.aging_8_10 }}</span>
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,item.ctrl_processo_id ?? null,null,0,0,'11_15', item.ctrl_familia_id ?? null)">{{ item.aging.aging_11_15 }}</span>
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,item.ctrl_processo_id ?? null,null,0,0,'16_30', item.ctrl_familia_id ?? null)">{{ item.aging.aging_16_30 }}</span>
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,item.ctrl_processo_id ?? null,null,0,0,'31_60', item.ctrl_familia_id ?? null)">{{ item.aging.aging_31_60 }}</span>
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,item.ctrl_processo_id ?? null,null,0,0,'maior_60', item.ctrl_familia_id ?? null)">{{ item.aging.aging_maior_60 }}</span>
        </td>
        <td class="valor-aging">
          <span class="cursor-pointer" @click="detalharTarefas($event,item.ctrl_processo_id ?? null,null,0,0,null, item.ctrl_familia_id ?? null)">{{ item.aging.aging_total }}</span>
        </td>
      </tr>
    </template>

    <template v-if="!nivelUnico" v-slot:expanded-item="{ headers, item }">
      <td class="expand-aging tabela_tarefas_td"></td>
      <td :colspan="headers.length - 1" class="tabela_tarefas_td">                 
        <v-data-table
          ref="tabAging"
          :headers="headerTabelaTarefasPorAgings"
          :items="item.tarefas"
          hide-default-header
          hide-default-footer
          class="custom_table_tarefas_aging"
          :calculateWidths="true"
          disable-pagination
        >
        <template v-slot:item="{ item }">
          <tr>
            <td class="titulo-aging">
              {{ item.sub_item }}
            </td>
            <td class="valor-aging">
              <span class="cursor-pointer" @click="detalharTarefas($event,null,item.ctrl_tarefa_id,0,0,'0')">{{ item.aging.aging_0 }}</span>
            </td>
            <td class="valor-aging">
              <span class="cursor-pointer" @click="detalharTarefas($event,null,item.ctrl_tarefa_id,0,0,'1')">{{ item.aging.aging_1 }}</span>
            </td>
            <td class="valor-aging">
              <span class="cursor-pointer" @click="detalharTarefas($event,null,item.ctrl_tarefa_id,0,0,'2')">{{ item.aging.aging_2 }}</span>
            </td>
            <td class="valor-aging">
              <span class="cursor-pointer" @click="detalharTarefas($event,null,item.ctrl_tarefa_id,0,0,'3')">{{ item.aging.aging_3 }}</span>
            </td>
            <td class="valor-aging">
              <span class="cursor-pointer" @click="detalharTarefas($event,null,item.ctrl_tarefa_id,0,0,'4')">{{ item.aging.aging_4 }}</span>
            </td>
            <td class="valor-aging">
              <span class="cursor-pointer" @click="detalharTarefas($event,null,item.ctrl_tarefa_id,0,0,'5')">{{ item.aging.aging_5 }}</span>
            </td>
            <td class="valor-aging">
              <span class="cursor-pointer" @click="detalharTarefas($event,null,item.ctrl_tarefa_id,0,0,'6')">{{ item.aging.aging_6 }}</span>
            </td>
            <td class="valor-aging">
              <span class="cursor-pointer" @click="detalharTarefas($event,null,item.ctrl_tarefa_id,0,0,'7')">{{ item.aging.aging_7 }}</span>
            </td>
            <td class="valor-aging">
              <span class="cursor-pointer" @click="detalharTarefas($event,null,item.ctrl_tarefa_id,0,0,'8_10')">{{ item.aging.aging_8_10 }}</span>
            </td>
            <td class="valor-aging">
              <span class="cursor-pointer" @click="detalharTarefas($event,null,item.ctrl_tarefa_id,0,0,'11_15')">{{ item.aging.aging_11_15 }}</span>
            </td>
            <td class="valor-aging">
              <span class="cursor-pointer" @click="detalharTarefas($event,null,item.ctrl_tarefa_id,0,0,'16_30')">{{ item.aging.aging_16_30 }}</span>
            </td>
            <td class="valor-aging">
              <span class="cursor-pointer" @click="detalharTarefas($event,null,item.ctrl_tarefa_id,0,0,'31_60')">{{ item.aging.aging_31_60 }}</span>
            </td>
            <td class="valor-aging">
              <span class="cursor-pointer" @click="detalharTarefas($event,null,item.ctrl_tarefa_id,0,0,'maior_60')">{{ item.aging.aging_maior_60 }}</span>
            </td>
            <td class="valor-aging">
              <span class="cursor-pointer" @click="detalharTarefas($event,null,item.ctrl_tarefa_id,0,0,null)">{{ item.aging.aging_total }}</span>
            </td>
          </tr>
        </template>  
        </v-data-table>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: "TabelaAgingComponent",

  props: {
    lista: {
      type: Array,
      required:false,
      default: () => []
    },
    descricaoTitulo: {
      type: String,
      required: true
    },
    descricaoTabela: {
      type: String,
      required: true
    },
    nivelUnico: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      singleExpand: false,
      btnExpand: false,
      expanded: [],
    }
  },

  methods: {

    toggleExpand(item) {
      this.expanded = this.expanded[0] === item ? [] : [item];
    },
    
    detalharTarefas (event, ctrlProcesso,ctrlTarefa,interrompida,emCancelamento,aging,ctrlFamiliaId=null) {
      let emAtendimento = 1;
      this.$emit('detalharTarefasEmit', {
        event,
        ctrlProcesso,
        ctrlTarefa,
        emAtendimento,
        interrompida,
        emCancelamento,
        aging,
        ctrlFamiliaId
      });
    },

    expandAll (items) {            
      if (!this.btnExpand) {
        this.expanded = items
      } else {
        this.expanded = []
      }
      this.btnExpand = !this.btnExpand
    },

  },

  computed: {
    ...mapGetters('backlog', 
    [
      'listaTarefas',
      'loadingBacklog'
    ]),

    headersInterrupcoesAging () {
      return [
        { 
          text: this.descricaoTabela,
          align: 'left',
          value: 'item',
          class:'titulo-aging'
          
        },
        { 
          text: '0',
          align: 'center',
          value: 'aging.aging_0',
          class: 'valor-aging'
        },
        { 
          text: '1',
          align: 'center',
          value: 'aging.aging_1',
          class: 'valor-aging'
        },        
        { 
          text: '2',
          align: 'center',
          value: 'aging.aging_2',
          class: 'valor-aging'
        },
        { 
          text: '3',
          align: 'center',
          value: 'aging.aging_3',
          class: 'valor-aging'
        },
        { 
          text: '4',
          align: 'center',
          value: 'aging.aging_4',
          class: 'valor-aging'
        },
        { 
          text: '5',
          align: 'center',
          value: 'aging.aging_5',
          class: 'valor-aging'
        },
        { 
          text: '6',
          align: 'center',
          value: 'aging.aging_6',
          class: 'valor-aging'
        },
        { 
          text: '7',
          align: 'center',
          value: 'aging.aging_7',
          class: 'valor-aging'
        },
        { 
          text: '8 a 10',
          align: 'center',
          value: 'aging.aging_8_10',
          class: 'valor-aging'
        },
        { 
          text: '11 a 15',
          align: 'center',
          value: 'aging.aging_11_15',
          class: 'valor-aging'
        },
        { 
          text: '16 a 30',
          align: 'center',
          value: 'aging.aging_16_30',
          class: 'valor-aging'
        },
        { 
          text: '31 a 60',
          align: 'center',
          value: 'aging.aging_31_60',
          class: 'valor-aging'
        },
        { 
          text: '> 60',
          align: 'center',
          value: 'aging.aging_maior_60',
          class: 'valor-aging'
        },
        { 
          text: 'TOTAL GERAL',
          align: 'center',
          value: 'aging.aging_total',
          class: 'valor-aging'
        }
      ]
    },

    headerTabelaTarefasPorAgings() {
      return [
        { 
          text: '',
          align: 'start',
          value: 'item',
          width: '320px'         
        },
        { 
          text: '0',
          align: 'center',
          value: 'aging.aging_0',
          width: '60px'
        },
        { 
          text: '1',
          align: 'center',
          value: 'aging.aging_1',
          width: '60px'
        },
        { 
          text: '2',
          align: 'center',
          value: 'aging.aging_2',
          width: '60px'
        },
        { 
          text: '3',
          align: 'center',
          value: 'aging.aging_3',
          width: '60px'
        },
        { 
          text: '4',
          align: 'center',
          value: 'aging.aging_4',
          width: '60px'
        },
        { 
          text: '5',
          align: 'center',
          value: 'aging.aging_5',
          width: '60px'
        },
        { 
          text: '6',
          align: 'center',
          value: 'aging.aging_6',
          width: '60px'
        },
        { 
          text: '7',
          align: 'center',
          value: 'aging.aging_7',
          width: '60px'
        },
        { 
          text: '8 a 10',
          align: 'center',
          value: 'aging.aging_8_10',
          width: '60px'
        },
        { 
          text: '11 a 15',
          align: 'center',
          value: 'aging.aging_11_15',
          width: '60px'
        },
        { 
          text: '16 a 30',
          align: 'center',
          value: 'aging.aging_16_30',
          width: '60px'
        },
        { 
          text: '31 a 60',
          align: 'center',
          value: 'aging.aging_31_60',
          width: '60px'
        },
        { 
          text: '> 60',
          align: 'center',
          value: 'aging.aging_maior_60',
          width: '60px'
        },
        { 
          text: 'TOTAL GERAL',
          align: 'center',
          value: 'aging.aging_total',
          width: '60px'
        }
      ]
    },
  },

}
</script>